<template>
    <div class="px-4 w-full">
        <slot />
    </div>
</template>
